module.exports = __webpack_public_path__ + "img/9788988578971.be0b2ef3.jpg";